import type { EventId } from '@ps/web-sports-api-types';
import classNames from 'clsx';
import React from 'react';

import type { TennisMatch } from '@swf/generated/graphql/scoreboards/schemas';
import EventStatus from '@swf/sports/components/EventStatus/EventStatus';
import useParticipants from '@swf/sports/hooks/useParticipants';
import { EventTypeId } from '@swf/sports/types/eventType';

import Score from '../Score/Score';

import styles from './Tennis.scss';

interface Props {
  name: string;
  eventId: EventId;
  eventTime: string;
  tennisMatch?: TennisMatch;
  hasDarkBackground?: boolean;
}
const Tennis: React.FC<Props> = ({ tennisMatch, name, eventId, eventTime, hasDarkBackground }) => {
  const [teamAName, teamBName] = useParticipants(name)?.map(({ participant }) => participant) ?? [];
  const currentTeamServing = tennisMatch?.currentSet?.currentGame?.teamServing;
  const teamAScore = {
    isServing: currentTeamServing === 'HOME',
    setScore: tennisMatch?.teamAScore,
    currentSetGameScore: tennisMatch?.currentSet?.teamAScore,
    currentGamePointScore: tennisMatch?.currentSet?.currentGame?.teamAScore
  };
  const teamBScore = {
    isServing: currentTeamServing === 'AWAY',
    setScore: tennisMatch?.teamBScore,
    currentSetGameScore: tennisMatch?.currentSet?.teamBScore,
    currentGamePointScore: tennisMatch?.currentSet?.currentGame?.teamBScore
  };

  return (
    <div
      className={classNames(styles.wrapper, {
        [styles.darkBackground]: hasDarkBackground
      })}
    >
      <div className={styles.status}>
        <EventStatus
          eventId={eventId}
          inPlay
          canTurnInPlay
          startTime={eventTime}
          size="XSmall"
          eventTypeId={EventTypeId.TENNIS}
        />
      </div>
      <div
        className={classNames(styles.team, styles.teamA, {
          [styles.serving]: teamAScore.isServing
        })}
      >
        {teamAName}
      </div>
      <div className={classNames(styles.score, styles.teamASetScore)}>
        <Score score={teamAScore.setScore} />
      </div>
      <div className={classNames(styles.score, styles.teamACurrentSetGameScore)}>
        <Score score={teamAScore.currentSetGameScore} />
      </div>
      <div className={classNames(styles.score, styles.teamACurrentGamePointScore)}>
        <Score score={teamAScore.currentGamePointScore} isHighlighted />
      </div>

      <div
        className={classNames(styles.team, styles.teamB, {
          [styles.serving]: teamBScore.isServing
        })}
      >
        {teamBName}
      </div>
      <div className={classNames(styles.score, styles.teamBSetScore)}>
        <Score score={teamBScore.setScore} />
      </div>
      <div className={classNames(styles.score, styles.teamBCurrentSetGameScore)}>
        <Score score={teamBScore.currentSetGameScore} />
      </div>
      <div className={classNames(styles.score, styles.teamBCurrentGamePointScore)}>
        <Score score={teamBScore.currentGamePointScore} isHighlighted />
      </div>
    </div>
  );
};

export default Tennis;
